import { useNavigate } from '@tanstack/react-router'
import { useEffect, useRef } from 'react'
import { useChainId } from 'wagmi'

import { useSandbox } from '@/domain/sandbox/useSandbox'
import { InternalLink } from '@/routing/types'

interface UseSandboxPageRedirectParams {
  redirect: InternalLink
  fallback: InternalLink
}

export function useSandboxPageRedirect({ redirect, fallback }: UseSandboxPageRedirectParams): void {
  const chainId = useChainId()
  const prevChainIdRef = useRef<number | undefined>(chainId)
  const { sandboxChainId, originChainId } = useSandbox()
  const navigate = useNavigate()

  useEffect(() => {
    const redirectParams = redirect.params as { chainId: number } | undefined
    const prevChainId = prevChainIdRef.current

    if (prevChainId !== undefined && chainId !== prevChainId) {
      if (chainId === sandboxChainId && prevChainId === originChainId && prevChainId === redirectParams?.chainId) {
        void navigate({ ...redirect, params: { ...redirectParams, chainId: sandboxChainId } } as InternalLink)
      } else {
        void navigate(fallback)
      }
    }

    prevChainIdRef.current = chainId
  }, [chainId, sandboxChainId, originChainId, redirect, fallback, navigate])
}
